export const LoginInfoData = {
    username:"",
    loginServerURL: "",
    token: ""
}